import { render, staticRenderFns } from "./crowd-pack.vue?vue&type=template&id=71a887fc&scoped=true"
import script from "./crowd-pack.vue?vue&type=script&lang=js"
export * from "./crowd-pack.vue?vue&type=script&lang=js"
import style0 from "./crowd-pack.vue?vue&type=style&index=0&id=71a887fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a887fc",
  null
  
)

export default component.exports